import NewFeatureIndicator from './newFeatureIndicator'

export default NewFeatureIndicator
